import moment from 'moment';

import type { SavedFilter } from '@/types';

import ClientRequestDeleteIcon from '../PropertyRequests/RequestsMyListItem/svg/iconDelete.svg';
import ClientRequestEditIcon from '../PropertyRequests/RequestsMyListItem/svg/iconEdit.svg';
import { StyledButton as ClientRequestActionButton } from '../PropertyRequests/RequestsMyListItem/styled';
import { StyledButton } from '../uiComponents/styled';
import styles from './SavedFilters.module.scss';

interface SavedFilterItemProps {
  onApply: (savedFilter: SavedFilter) => void;
  onDelete: (savedFilter: SavedFilter) => void;
  onRename: (savedFilter: SavedFilter) => void;
  savedFilter: SavedFilter;
}

export const SavedFilterItem = ({
  onApply,
  onDelete,
  onRename,
  savedFilter,
}: SavedFilterItemProps) => (
  <li className={styles.listItem}>
    <article className={styles.card}>
      <div className={styles.cardHeader}>
        <h2 className={styles.cardName}>{savedFilter.name}</h2>
        <div className={styles.cardActions}>
          <ClientRequestActionButton
            aria-label={`Rename ${savedFilter.name}`}
            customWidth='40px'
            onClick={() => onRename(savedFilter)}
            styleType='onlyIcon'
            type='button'
            variant='contained'
          >
            <img alt='' src={ClientRequestEditIcon} />
          </ClientRequestActionButton>
          <ClientRequestActionButton
            aria-label={`Delete ${savedFilter.name}`}
            customWidth='40px'
            onClick={() => onDelete(savedFilter)}
            styleType='onlyIcon'
            type='button'
            variant='contained'
          >
            <img alt='' src={ClientRequestDeleteIcon} />
          </ClientRequestActionButton>
        </div>
      </div>
      <p className={styles.createdAt}>
        Created{' '}
        <time dateTime={savedFilter.createdAt}>
          {moment(savedFilter.createdAt).format('D MMMM YYYY')}
        </time>
      </p>
      <div className={styles.applyAction}>
        <StyledButton
          aria-label={`Apply ${savedFilter.name}`}
          onClick={() => onApply(savedFilter)}
          size='medium'
          type='button'
          variant='contained'
        >
          Apply
        </StyledButton>
      </div>
    </article>
  </li>
);
